import script from "./ActivityAddOrEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityAddOrEditModal.vue?vue&type=script&setup=true&lang=js"

import "./ActivityAddOrEditModal.vue?vue&type=style&index=0&id=1be987c4&lang=css"

const __exports__ = script;

export default __exports__